import type { MouseEvent } from 'react';

import { Editor } from 'slate';

import { BOLD, ITALIC, STRIKETHROUGH, UNDERLINE } from '../constants';
import type { Action, Kind } from '../toolbar/types';

export const clearFormatting = (editor: Editor) => {
  Editor.removeMark(editor, BOLD);
  Editor.removeMark(editor, ITALIC);
  Editor.removeMark(editor, UNDERLINE);
  Editor.removeMark(editor, STRIKETHROUGH);
};

export const getIsMarkActive = (editor: Editor, kind: Kind) => {
  const marks = Editor.marks(editor);

  return marks ? marks[kind] === true : false;
};

export const getOnMouseDown =
  (editor: Editor, kind: Kind, action: Action) => (event: MouseEvent) => {
    event.preventDefault();
    action(editor, kind);
  };

export const toggleMark = (editor: Editor, kind: Kind) => {
  const isMarkActive = getIsMarkActive(editor, kind);

  if (isMarkActive) {
    Editor.removeMark(editor, kind);
  } else {
    Editor.addMark(editor, kind, true);
  }
};
